module.exports = __webpack_public_path__ + "static/media/super-premium.1d1e9e39.svg";